import { toastr } from 'react-redux-toastr';

export const showAccessDeniedToast = () => {
    toastr.error(
        'Access denied',
        'You do not have the required access rights to access that part of the application...',
        {
            timeOut: 0,
            position: 'top-center',
        }
    );
};
